import { Paper } from '@mui/material'

import withStyles from '@mui/styles/withStyles'
import makeStyles from '@mui/styles/makeStyles'

export const StyledPaper = withStyles(() => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    height: 'auto',
    width: 'auto',
    padding: '1.5rem 2rem',

    '&:focus-visible': {
      outline: 'none'
    }
  }
}))(Paper)

const useStyles = makeStyles(theme => ({
  close: {
    position: 'absolute',
    top: '0.75rem',
    right: '1rem',
    opacity: '0.7',
    cursor: 'pointer',
    fontSize: theme.size.base
  }
}))

export default useStyles
